/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchRolesRequest
 */
export interface SearchRolesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchRolesRequest
     */
    companyGuids?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchRolesRequest
     */
    teamIds?: Array<string>;
}

/**
 * Check if a given object implements the SearchRolesRequest interface.
 */
export function instanceOfSearchRolesRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SearchRolesRequestFromJSON(json: any): SearchRolesRequest {
    return SearchRolesRequestFromJSONTyped(json, false);
}

export function SearchRolesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRolesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyGuids': !exists(json, 'company_guids') ? undefined : json['company_guids'],
        'teamIds': !exists(json, 'team_ids') ? undefined : json['team_ids'],
    };
}

export function SearchRolesRequestToJSON(value?: SearchRolesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_guids': value.companyGuids,
        'team_ids': value.teamIds,
    };
}

